import { PerformanceSubtaskDialog } from '@strata/react-performance';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { getElement } from 'components/valueCase/helpers';

export const PreviewSubtaskDialog = ({
    elementId = undefined,
    subtaskSource = undefined,
    subtaskObject = undefined,
}) => {
    const [subtaskObjectToUse, setSubtaskObjectToUse] = useState();
    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setSubtaskObjectToUse(
            (subtaskSource && elementId
                ? getElement({
                      distinctId: elementId,
                      namespace: 'subtask',
                      root: subtaskSource,
                  })[0]
                : undefined) ?? subtaskObject,
        );
    }, [subtaskSource, elementId, subtaskObject]);

    return (
        <PerformanceSubtaskDialog
            isOpen={!!(elementId || !!subtaskObjectToUse)}
            usePortal={false}
            enforceFocus={false}
            subtaskObject={subtaskObjectToUse}
            onSubmit={() => {}}
            onCancel={() => {}}
        />
    );
};

PreviewSubtaskDialog.propTypes = {
    elementId: PropTypes.string,
    subtaskSource: PropTypes.shape({}),
    subtaskObject: PropTypes.shape({}),
};
